/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 26th 2022, 1:00:42 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Badge from "@mui/material/Badge";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { COLORSCHEME } from "theme/styles";
import { User } from "lib/schemas";
import { useToggleState } from "ui-widgets";
import { UserProfileImageForm } from "./UserProfileImageForm";

interface UserProfileHeaderProps {
  user: User;
  setUser: React.Dispatch<React.SetStateAction<User>>;
  editModeCondition: boolean;
}

export const UserProfileHeader = ({ user, setUser, editModeCondition }: UserProfileHeaderProps) => {
  const { handleClose, handleOpen, open } = useToggleState();

  return (
    <>
      {editModeCondition ? (
        <UserProfileImageForm
          setUser={setUser}
          open={open}
          onClose={handleClose}
          registrationProfile={user?.registrationprofile}
        />
      ) : null}

      <div className="os-profile-header-container">
        <div className="os-profile-header-content" onClick={() => editModeCondition && handleOpen()}>
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            badgeContent={<PhotoCameraIcon fontSize="large" sx={{ color: COLORSCHEME.onPrimary }} />}
          >
            <Avatar
              sx={{
                width: 128,
                height: 128,
                cursor: "pointer",
              }}
              src={user.registrationprofile?.image}
            />
          </Badge>

          <Typography className="os-profile-header-title" variant="h3" color={COLORSCHEME.onPrimary}>
            {user.registrationprofile
              ? `${user.registrationprofile?.firstname} ${user.registrationprofile?.surname}`
              : user.username}
          </Typography>
        </div>
      </div>
    </>
  );
};
